import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { ActivatedRoute } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {
  loading = false;
  alert: Alert = null;
  errorStrings = ErrorStrings;
  model: any = {
    oldPassword: '',
    password: '',
  };
  user: User;
  isBrowser: boolean;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.isBrowser = isPlatformBrowser(this.platformId);
    
  }

  // TODO: When we have more time, we'll need to move the error handling inside the service
  save(form: NgForm) {
    this.closeAlert();
    this.loading = true;
    this.userService.updatePassword(this.model)
      .subscribe({
        next: () => {
          this.loading = false;
          form.reset();
          this.alert = {
            type: 'success',
            message: 'Your password has been updated.'
          };
          this.trackEvent('pwchange::updated');
        },
        error: err => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.loading = false;
            form.reset();
            this.alert = {
              type: 'danger',
              message: 'The current password entered is incorrect.'
            };
          } else {
            this.loading = false;
            form.reset();
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
          }
        }
      })
  }

  closeAlert() {
    this.alert = null;
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
  }
}
